var modalContainer = document.getElementById("loginModalContainer");
var modal = document.getElementById("loginModal");
var btn = document.getElementById("loginBtn");
var span = document.getElementsByClassName("close-modal")[0];
var languageContainer2 = document.getElementById("languageModalContainer");
var languageModal2 = document.getElementById("languageModal");

if (btn) {
  btn.onclick = function () {
    languageContainer?.classList.remove("show");
    languageModal?.classList.remove("slide-up");
    modalContainer.classList.add("show");
    modal.classList.add("slide-up");
  };
}
span.onclick = function () {
  modalContainer.classList.remove("show");
  modal.classList.remove("slide-up");
};

document.addEventListener("focusin", function (event) {
  if (!modal.contains(event.target)) {
    modalContainer.classList.remove("show");
    modal.classList.remove("slide-up");
  }
});

var loginForm = document.querySelector('form[action="/account/login"]');

if (loginForm) {
  loginForm.addEventListener("submit", function (event) {
    var currentUrl = window.location.pathname;

    var inputReturnTo = document.createElement("input");
    inputReturnTo.type = "hidden";
    inputReturnTo.name = "return_to";
    inputReturnTo.value = currentUrl;
    loginForm.appendChild(inputReturnTo);
  });
}
